import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { LanguageContext } from "../../../context/LanguageContext";
import "./AnnouncementDetails.css";

const AnnouncementDetails = () => {
  const { slug  } = useParams();
  const [id, date] = slug.split("--");
  const { language } = useContext(LanguageContext);
  const [announcement, setAnnouncement] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch('https://script.google.com/macros/s/AKfycbzOo7F3e0SIcLMVdk3YKYMeLfciW5VlLUGJuESNiAux4MSqO9hITcl8I3MlQtN7E1o05Q/exec'); 
        const data = await res.json();
        // const found = data.find((item) => String(item.id) === String(id));
        const found = data.find((item) => {
  const itemId = String(item.id);
  const itemDate = new Date(item.publishDate).toISOString().split("T")[0];
  const requestedDate = new Date(date).toISOString().split("T")[0];

  return itemId === id && itemDate === requestedDate;
});

        setAnnouncement(found);
      } catch (err) {
        console.error("Failed to load announcement details:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [language, id, date]);

  if (isLoading) {
    return (
      <div className="announcement-details" dir={language === "ar" ? "rtl" : "ltr"}>
        <p className="loading-message">
          {language === "ar" ? "جاري التحميل..." : "Loading..."}
        </p>
      </div>
    );
  }

  if (!announcement) {
    return (
      <div className="announcement-details" dir={language === "ar" ? "rtl" : "ltr"}>
        <h2>{language === "ar" ? "الإعلان غير موجود" : "Announcement Not Found"}</h2>
      </div>
    );
  }

  const now = new Date();
  const unpublishDate = announcement.unpublishDate
    ? new Date(announcement.unpublishDate)
    : null;
  const isExpired = unpublishDate && now > unpublishDate;

  if (isExpired) {
    return (
      <div className="announcement-details" dir={language === "ar" ? "rtl" : "ltr"}>
        <h2>{language === "ar" ? "الإعلان غير متاح" : "Announcement Not Available"}</h2>
      </div>
    );
  }

  const title = language === "ar" ? announcement.title_ar : announcement.title_en;
  const description = language === "ar" ? announcement.description_ar : announcement.description_en;
  const fullDetails = language === "ar" ? announcement.fullDetails_ar : announcement.fullDetails_en;

  let attachments = [];
  try {
    attachments = JSON.parse(announcement.attachments || '[]');
  } catch (e) {
    attachments = [];
  }

  return (
    <div className="announcement-details" dir={language === "ar" ? "rtl" : "ltr"}>
      <div className="fade-transition" key={language}>
        <h2>{title}</h2>
        <p className="announcement-date">
          {new Date(announcement.publishDate).toLocaleDateString(language === "ar" ? "ar-EG" : "en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
          })}
        </p>
        <p className="announcement-description">{description}</p>
        <p className="announcement-full-details">{fullDetails}</p>

        <div className="announcement-contact">
          <p>
            {language === "ar" ? "البريد الإلكتروني: " : "Email: "}
            <a href="mailto:shareholders@falcomholding.com.sa">
              shareholders@falcomholding.com.sa
            </a>
          </p>
          <p>
            {language === "ar" ? "الهاتف الأرضي: " : "Landline: "}
            <a href="tel:0112114735">0112114735</a>
          </p>

          {attachments.length > 0 && (
            <div className="attachments-section">
              <h3>{language === "ar" ? "المرفقات" : "Attachments"}</h3>
              <div className="attachments-grid">

                {attachments.map((file, index) => (
                  <div key={index} className="attachment-card">
                    <p className="attachment-name">{file.split("/").pop()}</p>
                    <a id="download" href={file} download>
                      {language === "ar" ? "تحميل" : "Download"}
                         </a>
                         </div>
                        ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AnnouncementDetails;
